import React from "react";

export class Videos {
    static TextMeditation1BG = "./toi/meditations/meditationsBG_1_loop.mp4"
    static TextMeditation2BG = "./toi/meditations/meditationsBG_2_loop.mp4"
    static TextMeditation3BG = "./toi/meditations/meditationsBG_3_loop.mp4"
}

export class Images {
    static Meditation1Icon = "./toi/meditations/chalace_icon.gif";
    static Meditation2Icon = "./toi/meditations/bird_icon.gif";
    static Meditation3Icon = "./toi/meditations/iceball_icon.gif";
}

export class Text {
    static AboutRaw = [
        "Cybershore Meditations is a portal for accessing 3 meditations for journaling, somatic practice and unconscious reasoning (as coined by Marcus Coates). The meditations facilitate breathwork and imaginative embodying to bring attention to internal landscapes that aren’t habitually stimulated through the ways we interact with technology. Personal data is constantly harvested and used to shape the futuristic cultures, cyber-landscapes and cyber-interactions that serve the capitalist agenda. Cybershore Meditations encourages the surfacing of deeply personal thought, fantasy and emotive texture to bring forward offerings towards collective embodied futuring, beyond surface attention spans and personalised advertising.",
        "“I stand at the threshold of cyberspace and wonder, is it possible that I am unwelcome here, too? Will I be allowed to construct a virtual reality that empowers me? Can invisible men see their own reflections?” Essex Hemphill",
        "The setting of Cybershore Meditations’ 3D world is loosely based on the Salar de Uyuni in Bolivia, the world’s largest salt flat, which holds a large amount of the world’s known Lithium resource and attracts considerable extraction investment. As well as being a mineral resource for technology’s growing demands, it is also a mythical space that attracts tourists who want to experience its surreal mirrored landscape and holds cultural significance for local communities who associate the Salar with mountain deity Tunupa. These intersecting interests make Salar de Uyuni a culturally poignant place through which to explore technological futuring and its material implications.",
        "The Aymara legend of Tunupa and the Inuit legend of Sedna are woven into the meditations, allowing the imaginal landscapes of listeners - with various cultural or familial associations - to meet with indigenous perspectives and stories of geologies and deep time. The meditations guide listeners through different time horizons, beyond current cultural implications to explore their geological, embodied and emotive relationships to Earth and its possible histories and futures.",
    ]
    
    static About = [
        <p>
            <i>Cybershore Meditations</i> is a portal for accessing 3 meditations for journaling, somatic practice and
            unconscious reasoning (as coined by Marcus Coates). The meditations facilitate breathwork and imaginative
            embodying to bring attention to internal landscapes that aren’t habitually stimulated through the ways we
            interact with technology. Personal data is constantly harvested and used to shape the futuristic cultures,
            cyber-landscapes and cyber-interactions that serve the capitalist agenda. Cybershore Meditations encourages
            the surfacing of deeply personal thought, fantasy and emotive texture to bring forward offerings towards
            collective embodied futuring, beyond surface attention spans and personalised advertising.
        </p>,
        <p>
            “I stand at the threshold of cyberspace and wonder, is it possible that I am unwelcome here, too? Will I be
            allowed to construct a virtual reality that empowers me? Can invisible men see their own reflections?”
            <i>- Essex Hemphill</i> 
        </p>,
        <p>
            The setting of <i>Cybershore Meditations’</i> 3D world is loosely based on the Salar de Uyuni in Bolivia, the
            world’s largest salt flat, which holds a large amount of the world’s known Lithium resource and attracts
            considerable extraction investment. As well as being a mineral resource for technology’s growing demands, it
            is also a mythical space that attracts tourists who want to experience its surreal mirrored landscape and
            holds cultural significance for local communities who associate the Salar with mountain deity Tunupa. These
            intersecting interests make Salar de Uyuni a culturally poignant place through which to explore
            technological futuring and its material implications.
        </p>,
        <p>
            The Aymara legend of Tunupa and the Inuit legend of Sedna are woven into the meditations, allowing the
            imaginal landscapes of listeners - with various cultural or familial associations - to meet with indigenous
            perspectives and stories of geologies and deep time. The meditations guide listeners through different time
            horizons, beyond current cultural implications to explore their geological, embodied and emotive
            relationships to Earth and its possible histories and futures.
        </p>
    ]
}


export function Meditation1Text() {
    return (
        <div id={"meditation text"}>
            <p>
                Find a place to stand where your arms can stretch out without<br/> touching anything<br/> If you prefer
                to sit you are welcome to sit<br/></p>

            <p>
                Plant your feet down into the ground, think about the surface of<br/> your feet and where they connect
                to the floor<br/> Let your weight sway forwards onto your toes<br/> Backwards into your
                heels<br/> Softly sway your weight onto your right foot<br/> then to your left foot<br/> Sway side to
                side, backwards and forwards, maybe in circles,<br/> and changing directions<br/> Find a centre point
                for your weight to fall into<br/> Feel the sensation of gravity like a relentless waterfall
                through<br/> your centre<br/></p>

            <p>
                Scan your body up from your feet to check in on how your body<br/> is feeling<br/> How are your ankles
                and calves and thighs and hip sockets, your<br/> reproductive organs<br/> How is your belly and your
                ribs, lower back,<br/> spine and shoulder blades<br/> And all the parts in between<br/> Fingers arms
                neck<br/> Wiggle any part if you want to<br/> Does the feeling of each body part change when you bring
                your<br/> attention to it<br/> Ears, face, nose, crown of your head…<br/></p>

            <p>
                Take your attention to your breathing<br/> With every exhalation try to get a little more
                comfortable<br/> Sigh<br/> With every inhalation feel an expansion in your body<br/> like a
                balloon<br/> Taking the external into your internal,<br/> sending the internal back into the
                air<br/> Constant exchange<br/> Each breath complete<br/> If you like put your hands on your belly to
                feel the expansion of<br/> your diaphragm with every inhalation<br/> And contraction with every
                exhalation<br/> Rising and falling<br/> If there is anywhere in your body that feels like it’s holding
                pain<br/> or tension, think of breathing into that place, filling the area with<br/> oxygen as you
                inhale and with the exhale, try to release any tension<br/> If there is pain be gentle and don’t
                push,<br/> just breathe and release<br/></p>

            <p>
                Imagine sending your breath to different parts of your body,<br/> expanding that area with every
                inhalation and releasing<br/> and contracting with every exhalation,<br/> even if it’s just in your
                imagination, feeling different parts of your<br/> body rise and fall,<br/> like you are a balloon puppet
                taking fuller shape with<br/> every inhale<br/></p>

            <p>
                We will try breathing with an even ratio:<br/> Inhale for 2<br/> hold for 2<br/> exhale for 2<br/> hold
                for 2<br/> do this four times<br/></p>

            <p>
                While that constant exchange repeats, even as you hold the<br/> breath, visualise the constant flow and
                movement inside your<br/> body, even as you stand here still, your heartbeat, currents<br/> through your
                veins, signals and synapses, microbes and bacteria<br/> breaking things down and in other places
                repairing and healing.<br/></p>

            <p>
                Place your hands on your chest<br/> and breath into your heart space<br/> Is there any tension or
                feeling you are holding here that you can<br/> release with the outbreath into the air<br/></p>

            <p>
                Keep your feet sturdily planted on the floor,<br/> and in your minds eye I would like you to imagine
                walking to<br/> your front door,<br/> out of your house or away from wherever you are right now<br/> and
                finding the nearest tree<br/> This can either be a tree you remember<br/> being the closest one to
                you<br/> Or if you don’t remember you can guess or make one up<br/> How far do you have to go to find
                it?<br/></p>

            <p>
                What can you remember, or imagine about this tree?<br/> Can you picture the shapes of it’s branches and
                leaves,<br/> the colours, the texture and patterns in the bark<br/> The height of the tree, the width of
                it’s trunk<br/> I’d like you to take a moment to tell the tree<br/> how you’ve been feeling
                recently<br/> What have you felt in the last few days<br/></p>

            <p>
                When you’ve done that, thank the tree for listening,<br/> and if you like for transforming the
                atmosphere with you and<br/> providing oxygen for you,<br/> and make your way back to where you are now,<br/> returning
                the same way to where you are now,<br/> standing with your feet planted.<br/> Now we will imagine a
                different route,<br/> through the soles of your feet,<br/> growing roots that feel like limbs through
                the soles of your feet<br/> into the ground beneath you.<br/> Imagine the extremities of these roots
                like toes,<br/> nuzzling down into whatever surface you are on,<br/> whether it’s wood or concrete or
                soil,<br/> how far do your roots need to grow and nuzzle downwards to<br/> reach earthy soil, if there
                are other floors and rooms beneath<br/> you find pathways through those too to reach earthy
                crust<br/> and soil beneath,<br/> nuzzle in deeper and deeper,<br/> roots growing downwards like
                extensions<br/> of your legs and muscles,<br/> surrendering to a pull to the centre of the
                earth,<br/> leading with hyper dextrous toes, but branching off like roots<br/> through the
                soil<br/> What is this soil like, what is the temperature, dryness or moisture, creatures you pass,
                buried artefacts…<br/></p>

            <p>
                I’d like you to wriggle and stretch through the soil to find your<br/> way to a place you’ve been
                yearning to go<br/> Somewhere you strongly desire to go, somewhere you’ve been<br/> dreaming or hoping
                you could go<br/> You can take a moment to decide where this is, it can be a<br/> place you’ve been
                thinking about recently or somewhere you’ve<br/> wanted to go for a long time or somewhere that’s just
                come to<br/> mind that you’d like to go right now<br/> Find your way there through the deep layers of
                the Earth,<br/> direct your branching roots to find that place <br/></p>

            <p>
                Your toes can sprout through the surface of this place,<br/> squeezing through and creating space for
                yourself to slowly burst<br/> through the ground, like a timelapse of a tree growing,
                sprouting<br/> toes first, then branching legs<br/> Even if this is not a earthy soily place,<br/> you
                can burst through any surface<br/> sprouting toes first then branching legs,<br/> then torso emerging
                like a tree trunk,<br/> now your arms and fingers as roots,<br/> pushing your tree body up taller and
                taller,<br/> pull your shoulders and head through the surface<br/> and rest the crown of your head on
                the surface<br/> of this new place,<br/> pull your arms and hands through and plant them into
                the<br/> surface supporting your new upside down tree form,<br/> feeling the connection through your
                hands to the pathways<br/> of roots you grew beneath<br/></p>

            <p>
                You have arrived in the place you desired to go,<br/> though you are looking at it upside down in
                your<br/> tree body headstand.<br/> Take it in, the colour scheme, the temperature, the time of
                day<br/> or night it is here.<br/> You can stay in the headstand as long as your like,<br/> when you are
                ready, let your leafy toes and branching legs lower<br/> to the ground and return to your usual form
                as<br/> you bring yourself the right way round,<br/> hips on top on legs<br/> torso and spine on top on
                hips<br/> neck and head on top of shoulders<br/></p>

            <p>
                Take it in, the colour scheme, the temperature, the time of day<br/> or night it is here.<br/> Is it
                like you had hoped or is it different<br/> What is the landscape like, can you see far into the distance
                or<br/> are there things surrounding you, trees or buildings<br/> Are there other beings here, people,
                plants, animals, what companion species are here<br/> Shapes, architecture, textures<br/> Can you see
                the sky, what does it look like?<br/> Is there something you’d like to do here<br/> Something fun, some
                mission or action, something new or something you remember, or something you’d like to try<br/> You can
                do it now<br/> How does it feel to do<br/> What are you doing<br/> How are you doing it<br/> What is
                your body doing<br/> What is it interacting with<br/> How does it feel to do<br/> Enjoy it, if it’s
                enjoyable<br/> Deepen into the sensation and imagination of your activity, in this<br/> place<br/></p>

            <p>
                A faint ring in the air that you know means it’s time to leave<br/> here soon<br/> Before we leave
                here<br/> Choose something to bring with you from this place<br/> It can be something to do with your
                activity, your mission, an artefact, something you are holding in this place, something you<br/> find
                here<br/> What are the details of this object, the size, the weight, colour,<br/> texture.<br/> No
                matter the size, drop it in your pocket<br/></p>

            <p>
                Make your way back to the spot you sprouted through<br/> Dive and nuzzle back into the soil and follow
                the pathway of<br/> roots, back the way you came, navigating through the Earth to<br/> come back through
                the floor where you are now<br/> Back into your body<br/></p>

            <p>
                When you have arrived take a few deep breaths<br/> Settle in your body again<br/> Wriggle and stretch if
                you need to<br/> When you open your eyes go to a piece of paper or the textbox<br/> on the screen and
                write down everything you remember, all the<br/> details you remember<br/> Describe or draw the object
                you brought back with you with all<br/> the details you can<br/></p>


        </div>
    )
}

export function Meditation2Text() {
    return (
        <div id={"meditation text"}>
            <p>
                Find a place to stand where your arms can stretch out without<br/>If you prefer to sit you are welcome
                to sit<br/></p>

            <p>
                When you are ready close your eyes<br/>Circle your shoulders, stretch out your body, yawn, listen in to
                your body and move however you want to, fast slow, big or small, silly, soft, anything, follow a feeling
                of ease and pleasure<br/></p>

            <p>
                Settle<br/></p>

            <p>
                A large bird flies into your space,<br/>through the window if you are indoors, if you have no windows,
                the bird crashes through the wall.<br/>It is huge and powerful, about 3 times your size, with a round
                plump body, huge shining feathers and a curved beak.<br/>Though the bird is big it’s presence isn’t
                scary, it’s talons curl around your shoulders, the way it holds you feels comfortable and safe, like a
                harness, under the arms and around the chest, the bird picks you up and flies into the sky with you<br/>
            </p>

            <p>
                The bird takes you to a place of deep history,<br/>a place familiar to you, maybe a local heritage site
                or somewhere from your upbringing, somewhere connected to the ancient<br/></p>

            <p>
                The bird drops you gently onto your feet and flies away.<br/>Take in the landscape.<br/>How is the
                weather here, what time of day is it, can you see the sky, the colours, what colours are you
                seeing?<br/>What shades of those colours? Textures? How far into the horizon can you see? Are you high
                or low to sea level? Are there trees, buildings, beings…<br/></p>

            <p>
                Explore<br/>Experience<br/>Notice detail<br/>Allow things to change<br/>Don’t worry if you can’t hold
                onto the landscape allow things to come and go as you explore<br/></p>

            <p>
                Somewhere in this place you find an ancestor. This can be an ancestor of recent generations,
                great-great-grandparents or much much further back, 50 years or 100 years or 1000 years<br/>Keep
                exploring until you find your ancestor.<br/></p>

            <p>
                When you find them greet them. What do they look like? What are they wearing? What age do they appear to
                you as? What is their gender expression? What is the feeling of looking at their face? Is anything
                surprising, or familiar? Do they know you, do they recognise you too? Do they greet you back? Do they
                speak to you, can you talk to eachother?<br/></p>

            <p>
                Find somewhere to sit and rest with your ancestor, maybe looking at the view.<br/>I would like you to
                think of a time or moment where you felt empowered. What made you feel empowered?<br/>What happened to
                make you feel powerful, vital, proud, vibrant, strong… what were you doing?<br/>Did you achieve
                something or overcome or experience something special to you? vital to your being?<br/></p>

            <p>
                When you can remember, hold and understand something about this occasion of feeling powerful, I’d like
                you to explain the event to your ancestor. Explain whatever you want to about it to them. The situation,
                the actions, the causes, your thoughts about it.<br/></p>

            <p>
                Do they respond?<br/>Do they have anything to say about this?<br/></p>

            <p>
                When this conversation has concluded,<br/>take another walk into the landscape<br/>Somewhere in this
                place you find a door that looks like a phone. A phone that is the size of a door. Approach this
                door.<br/>Somehow you know what to do to open it, unlock the phonedoor and walk through it.<br/></p>

            <p>
                On the other side of this door is the Salar de Uyuni,<br/>Salt Flats in Bolivia, or somewhere that looks
                just like it,<br/>in the rainy season where the vast white flat is covered in large shallow puddles that
                reflect the sky.<br/>An endless watery mirror surface.<br/></p>

            <p>
                The Aymara locals say the nearby Volcano Tunupa created these salt flats, after being pinned to the
                Earth and so not being able to find her lost son, she poured tears and mother’s milk and created the
                Salar.<br/></p>

            <p>
                Here in this place I would like you to think of a time when you felt disempowered. What made you feel
                this way? What happened? Who or what did you feel was holding their power over or against you or taking
                your power away from you? What part of you was being oppressed that wanted to exist in that moment?<br/>
            </p>

            <p>
                The thing, person, system that caused this feeling,<br/>imagine them there in the salt flats with
                you,<br/>imagine the scene of this moment of disempowerment occurring. Feel the rumble of the
                heartbroken volcano in the distance, stirring to give you an opportunity<br/>to change something about
                this situation.<br/>From the volcano, from the sky or from the mirror surface below. You can change
                anything about this situation.<br/>Whether it is something happening<br/>to the cause of your
                oppression, expressing yourself differently, or some form of revenge, realistic or magical.<br/>You have
                the support of the volcano, the sky and<br/>the watery mirror below you for this.<br/></p>

            <p>
                Make a shape or posture with your body to represent how you feel at different points of this
                interaction.<br/>A shape or posture for the moment of feeling disempowered, and another one for the
                moment you realise you can change something with the help of the magic of this place and a shape or
                posture for how you feel afterwards. Move between these shapes and postures. How does it feel to change
                from one to the other?<br/></p>

            <p>
                Dance between these postures, imagine yourself doing this dance in the salt flats, in the endless
                mirrored floor landscape.<br/></p>

            <p>
                When you have concluded your dance it is time to go. You must return the way you came.<br/>You can say
                thank you and goodbye to the volcano if you wish, and go back through the phone-door,<br/>unlocking and
                walking through, to the old heritage landscape, passing your ancestor,<br/>and finding the bird that
                brought you here. The bird spreads its wings above you and wraps its perching feet and talons around
                your shoulders and chest, picks you up safely and brings you back to where you are this moment.<br/></p>

            <p>
                When you are ready, write down everything you recall, in any order. Write about your dance of
                disempowerment to resolution, gaining the power to change the past, the phone-door, volcano, the
                ancestor, the landscapes, the bird.<br/></p>


        </div>
    )
}

export function Meditation3Text() {
    return (
        <div id={"meditation text"}>
            
            <p>
                For this journey you can stay seated or lying down<br/>in a comfortable position on the floor,<br/>or
                if you prefer on a chair.<br/>When you are ready close your eyes.<br/>Notice your breathing, and with
                your exhalations deepen your sense of comfort and relaxation.<br/></p>

            <p>
                We will try breathing with an even ratio:<br/> Inhale for 2<br/>hold for 2<br/>exhale for 2<br/>hold for
                2<br/>do this four times<br/></p>

            <p>
                As you are breathing I would like you to imagine your body is freezing into a block of ice.<br/>Part by
                part, icicles grow around your skin and water flows around your form and hardens into a stiff ice block.<br/>Your
                system slows and is sustained in this block of ice.<br/>You are safe but you are dislocated from the
                world you know. You begin to float in this block of ice and lose notion of time, of how long has passed
                since you have been floating in this ice cube, where you might be and where everything else is.<br/>You
                float away for what might be centuries.<br/></p>

            <p>
                Eventually you sense your icy form lodged and settled somewhere. There is a warmth coming over now and
                the ice begins to crackle and thaw. You feel a release from the steady grip of the ice and can begin to
                wriggle your extremities,<br/>your neck and torso and legs freeing up and as the ice melts away to
                water.<br/></p>

            <p>
                You see as your ice shell melts and dissolves that the same thing is happening to a creature in front of
                you.<br/>This creature seems older than you and anything you’ve ever seen, an ice age creature.<br/>As
                your body is freeing up and regaining movement,<br/>unsticking from the ice, the same is happening
                to<br/>this other creature,<br/>ice melting away from it and it’s vitality recuperating.<br/>As you
                witness this you can decipher the details, whether it is a woolly mammoth or a deer or an elk or
                sloth<br/>or saber-tooth tiger or wolf or something else<br/></p>

            <p>
                Take your time to see the details of this creature.<br/>What does it look like, it’s skin or fur, eyes,
                stance, mood.<br/>Like you, it’s alive and regaining agency,<br/>you are witnessing eachother.<br/>You
                decide whether you move towards eachother, if the creature is approachable or hostile,<br/>if you can
                touch the being, if there is fear or softness,<br/>if you are able to regulate together after this<br/>disorientating
                experience or<br/>if you are thrown into a confrontation.<br/></p>

            <p>
                The ice below and surrounding you also begins melting and you and the creature begin to slip downwards
                together,<br/>as the surface you are on turns to water you begin to sink down into a huge body of water
                with currents stronger than you<br/>pulling you deeper.<br/>As you are sinking and floating your body
                seems to be merging with the creature you saw defrost in front of you,<br/>you are taking on features of
                this creature, the skin, the texture, the size, some parts of your form, you have somehow merged<br/>
            </p>

            <p>
                As you gain strength in your new form<br/>and the water feels warmer,<br/>swim downwards and explore
                this ocean.<br/>What do you see here, is it baron or populated, does anything appear to you?<br/></p>

            <p>
                As you swim downwards the water is darker and darker but there is a pull towards the depths,<br/>you
                must go towards a roaring you can hear below<br/></p>

            <p>
                When you reach the ocean floor you meet a large swollen<br/>sea-human, with no fingers and long tangled
                hair, knotted with debris from the ocean and trapped between thick heavy cables. She is furious being
                trapped by this entanglement and wailing in frustration. Her fingerless hands push you into her tangled
                mossy messy hair and you become trapped in it too,<br/>until you understand you must detangle it for
                her,<br/>and one by one begin pulling out the debris from her hair. You must be careful and patient to
                detangle<br/>though the sea-human is thrashing and struggling,<br/>you steadily release everything stuck
                here,<br/>take notice of what you find here and each object or being you release, untangling the strands
                from around the cables,<br/>the sea-human begins to calm and co-operate,<br/>realising her freedom and
                gratitude.<br/>Sea creatures escape from her hair, fish and seals and dolphins and begin to swim freely
                away, many creatures near extinction too, like the sea dragon and dumbo octopus, parts of technology
                too, rubbish and plastic and metals.<br/>The cables you untangle from her hair are long, stretching out
                into the distance.<br/>Sedna now talks calmly and firmly to you.<br/>Listen to her.<br/></p>

            <p>
                A giant green sea turtle swims out from her hair and you decide to hitch a ride.<br/>You stretch your
                arms over the shell,<br/>suck yourself

                onto it and glide along with the turtle. Below you can see the cables continuing along, you follow the
                same path, for miles.<br/></p>

            <p>
                Eventually the sea turtle brings you to a shore,<br/>that the thick cables also reach out onto<br/>and
                continue into the distance.<br/>As the sea turtle returns back into the sea, now you are alone here,
                washed up here on the sand,<br/>with the sensation you have travelled eras into the future.<br/></p>

            <p>
                How is your body feeling now after this journey,<br/>reconnect with your senses on this
                cyber-shore,<br/>how do you feel to be here, what colour is the sand, the sky, what does it smell like
                here, what else can you see and hear? There are signs that you have travelled far into the future. What
                signs?<br/></p>

            <p>
                If you follow the cables along further onto the land, where does it take you? What is this future
                landscape?<br/>What is there to explore? Where do the cables lead to?<br/></p>

            <p>
                What scenery do you imagine here?<br/>Are there buildings here in this futuristic landscape, what is the
                architecture like, what are the textures you see,<br/>what is the temperature like?<br/>Are there people
                here, other beings?<br/></p>

            <p>
                Explore here<br/>Experience this place, as it’s taken a lot for you to get here<br/></p>

            <p>
                Somewhere in this landscape you meet someone you recognise as a relative of yours, many generations into
                the future.<br/>They may be a blood relative or soulful one, you recognise something in them that makes
                you feel connected to them.<br/>What is it? What do they look like?<br/>How do they present themselves,
                are they wearing anything?<br/>What expression are they holding? Where do you find them? What were they
                doing? How similar or different is their form to yours? What is it like to meet them? Settle into this
                interaction, even if it’s glitchy and unstable. Let your relative take you somewhere, let them tell you
                something. Let there be glitches in the interaction, it’s ok if not everything is clear. What are they
                interested in about you, what do they want to know, what do you want to know? Take your time to ask
                them, to give them answers, to listen deeply to them.<br/></p>

            <p>
                A call in the distance means it’s time to go soon.<br/>Your relative takes you to the cables<br/>that
                lead eventually back into the sea.<br/>Touching the cables your size glitches down incrementally and you
                transport yourself inside of them, instantly swinging along into their current with disorientating
                speed, till they spit you out into the machine that you are listening to my voice through. The device
                that is in front of you.<br/>Allow yourself to travel back into your body through the screen, through
                the atmosphere and waves of light and sound between you and your device.<br/>Settle back into your body.<br/>
            </p>

            <p>
                When you are ready open your eyes. Write down everything you can recall, unfiltered, in any order. Your
                journey through ice, merging with an ice age creature, through the ocean meeting Sedna, into the future
                through the cyber shore, your experience of the future, your interaction with your future relative.<br/>
            </p>

        </div>
    )
}